module.exports = __webpack_public_path__ + "img/kelas-selesai.13c2f705.svg";